export default __webpack_public_path__ + "static/media/banner-bg-1-2.9bdc43b4.png";